import { RequestInfo } from 'undici-types'
let RequestInfo: RequestInfo
export const base64ToBlob = (base64: string | null) =>
  fetch(base64 !== null ? base64 : RequestInfo).then((res) => res.blob())
